import { Select } from "antd";
import _ from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { SelectDownIcon } from "@/Components/Icons/SelectDownIcon";
import {
  updateRecurrenceList,
  updateRepeatObj,
} from "@/reducers/clientcreatejob";
const EveryFrequency = () => {
  const { repeatObj } = useSelector((state) => state.clientCreateJob);
  const dispatch = useDispatch();
  const obj = {
    daily: "Day",
    weekly: "Week",
    monthly: "Month",
    yearly: "Year",
  };
  const getText = () => {
    return obj[repeatObj.frequency];
  };

  return (
    <div className="EveryFrequency_Wrapper">
      <div className="flex flex-col gap-3">
        <label className="label" htmlFor="everyFrequency">
          Every
        </label>
        <Select
          showSearch
          id="everyFrequency"
          style={{ width: "100%" }}
          placeholder="Select Role"
          optionFilterProp="children"
          className="ease min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey text-[14px] font-medium leading-[normal] text-black transition-all duration-200 focus:border-primary"
          suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
          onChange={(value) => {
            dispatch(
              updateRepeatObj({
                everyFrequency: parseInt(value.split(" ")[0]),
              }),
            );
            dispatch(updateRecurrenceList());
          }}
          value={`${repeatObj.everyFrequency} ${repeatObj.everyFrequency > 1 ? getText() + "s" : getText()}`}
        >
          {/* {frequencyPresets.map((item, index) => {
                const { label, value } = item;
                return (
                  <Select.Option value={value} key={index}>
                    {label}
                  </Select.Option>
                );
              })} */}
          {_.range(1, getText() === "Year" ? 11 : 200).map((item, index) => {
            return (
              <Select.Option
                value={`${item} ${parseInt(item) > 1 ? getText() + "s" : getText()}`}
                key={index}
              >
                {item} {parseInt(item) > 1 ? getText() + "s" : getText()}
              </Select.Option>
            );
          })}
        </Select>
      </div>
    </div>
  );
};

export default EveryFrequency;
